import {
  Pedestrismo,
  RuralBike,
  CombinadaSimple,
  CombinadaSprint,
  PedestrismoBackup
} from '../constants/enums';

import { actionTypes } from '../actions';


// gender: 0->M, 1->F

const initialState = {
  participantList: [],
  infoList: [],
  last: 1,
  catStats: [],
  gralStats: {}
};


export default function (state = initialState, action) {

  let newList = state.participantList.slice();

  switch (action.type) {


    /*
     * =======================================================
     * EDITAR TIEMPO
     * =======================================================
     */
    case actionTypes.EDIT_REGISTER_TIME:

      if (
        action.competition === PedestrismoBackup ||
        action.competition === Pedestrismo ||
        action.competition === RuralBike ||
        action.competition === CombinadaSimple
      ) {

        newList[action.index].registeredTime1 =
          action.now;

      } else {

        if (
          action.partial === 'formattedTime1'
        ) {

          newList[action.index].registeredTime1 =
            action.now;

          if (
            newList[action.index].registeredTime2 > 0
          ) {

            newList[action.index].registeredTime2 +=
              action.deltaTime;
          }

          if (
            newList[action.index].registeredTime3 > 0
          ) {

            newList[action.index].registeredTime3 +=
              action.deltaTime;
          }


        } else if (
          action.partial === 'formattedTime2'
        ) {

          newList[action.index].registeredTime2 =
            action.now;

          if (
            newList[action.index].registeredTime3 > 0
          ) {

            newList[action.index].registeredTime3 +=
              action.deltaTime;
          }


        } else if (
          action.partial === 'formattedTime3'
        ) {

          newList[action.index].registeredTime3 =
            action.now;
        }
      }


      newList[action.index].totalTime =
        newList[action.index].registeredTime1 +
        newList[action.index].registeredTime2 +
        newList[action.index].registeredTime3;


      return {
        ...state,
        participantList: newList
      };


    /*
     * =======================================================
     * DESREGISTRAR TIEMPO
     * =======================================================
     */
    case actionTypes.UNREGISTER_TIME:

      console.log("desregistrar tiempo");


      if (
        action.competition === Pedestrismo ||
        action.competition === PedestrismoBackup ||
        action.competition === RuralBike ||
        action.competition === CombinadaSimple
      ) {

        newList[action.index].registeredTime1 =
          action.now;

        newList[action.index].totalTime =
          newList[action.index].registeredTime1;

        /*
         * Al desregistrar dejamos nuevamente
         * al participante en estado normal.
         */
        newList[action.index].disqualified = 0;

        newList[action.index].dns = 0;


      } else {

        if (
          action.competition === CombinadaSprint
        ) {

          if (
            newList[action.index].registeredTime3 > 0
          ) {

            newList[action.index].registeredTime3 =
              action.now;

            newList[action.index].formattedTime3 = '';


          } else if (
            newList[action.index].registeredTime2 > 0
          ) {

            newList[action.index].registeredTime2 =
              action.now;

            newList[action.index].formattedTime2 = '';

            newList[action.index].registeredTime3 = 0;


          } else if (
            newList[action.index].registeredTime1 > 0
          ) {

            newList[action.index].registeredTime1 =
              action.now;

            newList[action.index].formattedTime1 = '';

            newList[action.index].registeredTime2 = 0;

            newList[action.index].registeredTime3 = 0;
          }


          newList[action.index].disqualified = 0;

          newList[action.index].dns = 0;


          newList[action.index].totalTime =
            newList[action.index].registeredTime1 +
            newList[action.index].registeredTime2 +
            newList[action.index].registeredTime3;


        } else {

          if (
            newList[action.index].registeredTime2 > 0
          ) {

            newList[action.index].registeredTime2 =
              action.now;

            newList[action.index].formattedTime2 = '';


          } else if (
            newList[action.index].registeredTime1 > 0
          ) {

            newList[action.index].registeredTime1 =
              action.now;

            newList[action.index].formattedTime1 = '';

            newList[action.index].registeredTime2 = 0;
          }


          newList[action.index].disqualified = 0;

          newList[action.index].dns = 0;


          newList[action.index].totalTime =
            newList[action.index].registeredTime1 +
            newList[action.index].registeredTime2;
        }
      }


      return {
        ...state,
        participantList: newList
      };


    /*
     * =======================================================
     * DNS
     * =======================================================
     *
     * Did Not Start
     *
     * Aplica a TODAS las competencias.
     *
     * - elimina tiempos
     * - dns = 1
     * - disqualified = 0
     */
    case actionTypes.DNS: {

      if (
        action.index === undefined ||
        action.index === null ||
        action.index < 0 ||
        action.index >= newList.length
      ) {

        return state;
      }


      newList[action.index].registeredTime1 = 0;

      newList[action.index].registeredTime2 = 0;

      newList[action.index].registeredTime3 = 0;


      newList[action.index].totalTime = 0;


      newList[action.index].dns = 1;

      newList[action.index].disqualified = 0;


      /*
       * Limpiamos posibles valores formateados.
       */
      newList[action.index].formattedTime1 = '';

      newList[action.index].formattedTime2 = '';

      newList[action.index].formattedTime3 = '';


      return {
        ...state,
        participantList: newList
      };
    }


    /*
     * =======================================================
     * DSQ
     * =======================================================
     *
     * Disqualified
     *
     * Aplica a TODAS las competencias.
     *
     * Conservamos la acción DISQUALIFY que
     * ya existía en el sistema.
     */
    case actionTypes.DISQUALIFY:

      newList[action.index].registeredTime1 = 0;

      newList[action.index].registeredTime2 = 0;

      newList[action.index].registeredTime3 = 0;


      newList[action.index].totalTime = 0;


      newList[action.index].disqualified = 1;

      /*
       * No puede ser DNS y DSQ simultáneamente.
       */
      newList[action.index].dns = 0;


      newList[action.index].formattedTime1 = '';

      newList[action.index].formattedTime2 = '';

      newList[action.index].formattedTime3 = '';


      return {
        ...state,
        participantList: newList
      };


    case actionTypes.INC_TIME:

      newList[action.index].registeredTime1 =
        action.now + 60000;

      newList[action.index].registeredTime2 = 0;

      newList[action.index].registeredTime3 = 0;


      newList[action.index].totalTime =
        newList[action.index].registeredTime1 +
        newList[action.index].registeredTime2 +
        newList[action.index].registeredTime3;


      return {
        ...state,
        participantList: newList
      };


    case actionTypes.DEC_TIME:

      newList[action.index].registeredTime1 =
        action.now - 60000;

      newList[action.index].registeredTime2 = 0;

      newList[action.index].registeredTime3 = 0;


      newList[action.index].totalTime =
        newList[action.index].registeredTime1 +
        newList[action.index].registeredTime2 +
        newList[action.index].registeredTime3;


      return {
        ...state,
        participantList: newList
      };


    /*
     * =======================================================
     * REGISTRO INDIVIDUAL
     * =======================================================
     *
     * Keyboard / Touch / carrera real
     */
    case actionTypes.REGISTER_TIME:

      let ultimo;


      if (
        action.index === undefined ||
        action.index === null ||
        action.index < 0 ||
        action.index >= newList.length
      ) {

        return state;
      }


      /*
       * Un DSQ no puede volver a registrar
       * tiempo accidentalmente.
       */
      if (
        Number(
          newList[action.index].disqualified || 0
        ) === 1
      ) {

        return state;
      }


      /*
       * Si estaba DNS y posteriormente ingresamos
       * normalmente su dorsal, interpretamos que
       * el DNS fue una corrección/error.
       *
       * El atleta vuelve automáticamente a estado
       * normal.
       */
      if (
        Number(
          newList[action.index].dns || 0
        ) === 1
      ) {

        newList[action.index].dns = 0;
      }


      if (
        action.competition === PedestrismoBackup ||
        action.competition === Pedestrismo ||
        action.competition === RuralBike ||
        action.competition === CombinadaSimple
      ) {

        if (
          newList[action.index].registeredTime1 === 0
        ) {

          newList[action.index].registeredTime1 =
            action.now;

          newList[action.index].registeredTime2 = 0;

          newList[action.index].registeredTime3 = 0;
        }


        ultimo =
          newList.filter(
            (participant) => {

              return (
                participant.registeredTime1 === 0 &&
                Number(
                  participant.dns || 0
                ) === 0 &&
                Number(
                  participant.disqualified || 0
                ) === 0
              );
            }
          );


      } else {

        if (
          newList[action.index].registeredTime1 === 0
        ) {

          newList[action.index].registeredTime1 =
            action.now;

          newList[action.index].registeredTime2 = 0;

          newList[action.index].registeredTime3 = 0;


        } else if (
          newList[action.index].registeredTime2 === 0
        ) {

          newList[action.index].registeredTime2 =
            action.now;

          newList[action.index].registeredTime3 = 0;


        } else if (
          newList[action.index].registeredTime3 === 0
        ) {

          newList[action.index].registeredTime3 =
            action.now;
        }


        ultimo =
          newList.filter(
            (participant) => {

              return (
                !participant.registeredTime2 &&
                Number(
                  participant.dns || 0
                ) === 0 &&
                Number(
                  participant.disqualified || 0
                ) === 0
              );
            }
          );
      }


      newList[action.index].totalTime =
        newList[action.index].registeredTime1 +
        newList[action.index].registeredTime2 +
        newList[action.index].registeredTime3;


      return {
        ...state,
        participantList: newList,
        last: ultimo.length
      };


    /*
     * =======================================================
     * REGISTRO MULTIPLE / BATCH
     * =======================================================
     *
     * Simulation utiliza esta acción.
     */
    case actionTypes.REGISTER_TIMES_BATCH: {

      const arrivals =
        Array.isArray(action.arrivals)
          ? action.arrivals
          : [];


      const replaceExisting =
        Boolean(
          action.replaceExisting
        );


      if (
        arrivals.length === 0
      ) {

        return state;
      }


      for (
        let i = 0;
        i < arrivals.length;
        i++
      ) {

        const arrival =
          arrivals[i];


        const index =
          arrival.index;


        if (
          index === undefined ||
          index === null ||
          index < 0 ||
          index >= newList.length
        ) {

          continue;
        }


        const participant =
          newList[index];


        if (
          !participant
        ) {

          continue;
        }


        /*
         * Simulation nunca modifica
         * participantes DNS ni DSQ.
         */
        if (
          Number(
            participant.disqualified || 0
          ) !== 0
          ||
          Number(
            participant.dns || 0
          ) !== 0
        ) {

          continue;
        }


        if (
          action.competition === PedestrismoBackup ||
          action.competition === Pedestrismo ||
          action.competition === RuralBike ||
          action.competition === CombinadaSimple
        ) {

          if (
            replaceExisting ||
            participant.registeredTime1 === 0
          ) {

            participant.registeredTime1 =
              arrival.now;

            participant.registeredTime2 = 0;

            participant.registeredTime3 = 0;


            participant.totalTime =
              participant.registeredTime1;
          }


        } else {

          if (
            replaceExisting
          ) {

            participant.registeredTime1 =
              arrival.now;

            participant.registeredTime2 = 0;

            participant.registeredTime3 = 0;


          } else if (
            participant.registeredTime1 === 0
          ) {

            participant.registeredTime1 =
              arrival.now;

            participant.registeredTime2 = 0;

            participant.registeredTime3 = 0;


          } else if (
            participant.registeredTime2 === 0
          ) {

            participant.registeredTime2 =
              arrival.now;

            participant.registeredTime3 = 0;


          } else if (
            participant.registeredTime3 === 0
          ) {

            participant.registeredTime3 =
              arrival.now;
          }


          participant.totalTime =
            participant.registeredTime1 +
            participant.registeredTime2 +
            participant.registeredTime3;
        }
      }


      /*
       * last se calcula UNA SOLA VEZ
       * después del batch.
       *
       * DNS y DSQ ya no cuentan como
       * atletas pendientes.
       */
      let batchLast;


      if (
        action.competition === PedestrismoBackup ||
        action.competition === Pedestrismo ||
        action.competition === RuralBike ||
        action.competition === CombinadaSimple
      ) {

        batchLast =
          newList.reduce(
            (count, participant) => {

              const pending =
                participant.registeredTime1 === 0
                &&
                Number(
                  participant.dns || 0
                ) === 0
                &&
                Number(
                  participant.disqualified || 0
                ) === 0;


              return (
                pending
                  ? count + 1
                  : count
              );
            },
            0
          );


      } else {

        batchLast =
          newList.reduce(
            (count, participant) => {

              const pending =
                !participant.registeredTime2
                &&
                Number(
                  participant.dns || 0
                ) === 0
                &&
                Number(
                  participant.disqualified || 0
                ) === 0;


              return (
                pending
                  ? count + 1
                  : count
              );
            },
            0
          );
      }


      return {
        ...state,
        participantList: newList,
        last: batchLast
      };
    }


    /*
     * =======================================================
     * CAMBIO OFFSET POR DISTANCIA
     * =======================================================
     *
     * Utilizado por Pedestrismo.
     */
    case actionTypes.UPDATE_DISTANCE_OFFSET: {

      const distance =
        String(
          action.distance || ''
        ).trim();


      const deltaMs =
        Number(
          action.deltaMinutes || 0
        ) *
        60 *
        1000;


      if (
        distance === '' ||
        deltaMs === 0
      ) {

        return state;
      }


      newList =
        newList.map(
          (participant) => {

            const participantDistance =
              String(
                participant.distance || ''
              ).trim();


            if (
              participantDistance !== distance
            ) {

              return participant;
            }


            /*
             * DNS y DSQ no tienen tiempo
             * que recalibrar.
             */
            if (
              Number(
                participant.dns || 0
              ) !== 0
              ||
              Number(
                participant.disqualified || 0
              ) !== 0
            ) {

              return participant;
            }


            if (
              !participant.registeredTime1 ||
              participant.registeredTime1 <= 0
            ) {

              return participant;
            }


            const updatedParticipant = {
              ...participant
            };


            const newRegisteredTime1 =
              updatedParticipant.registeredTime1 -
              deltaMs;


            updatedParticipant.registeredTime1 =
              Math.max(
                0,
                newRegisteredTime1
              );


            updatedParticipant.totalTime =
              updatedParticipant.registeredTime1 +
              (
                updatedParticipant.registeredTime2 ||
                0
              ) +
              (
                updatedParticipant.registeredTime3 ||
                0
              );


            return updatedParticipant;
          }
        );


      return {
        ...state,
        participantList: newList
      };
    }


    /*
     * =======================================================
     * CAMBIO OFFSET POR CATEGORIA
     * =======================================================
     *
     * Utilizado por:
     *
     * - Triatlón
     * - Duatlón
     * - Rural Bike / MTB
     *
     * La categoría se identifica mediante:
     *
     * participant.catCod
     *
     * Ejemplo:
     *
     * catCod = "CAB PRO"
     *
     * Si el offset cambia:
     *
     * anterior = 2
     * nuevo    = 4
     * delta    = +2
     *
     * El tiempo registrado debe disminuir
     * 2 minutos.
     */
    case actionTypes.UPDATE_CATEGORY_OFFSET: {

      const catCod =
        String(
          action.catCod || ''
        ).trim();


      const deltaMs =
        Number(
          action.deltaMinutes || 0
        ) *
        60 *
        1000;


      if (
        catCod === '' ||
        deltaMs === 0
      ) {

        return state;
      }


      newList =
        newList.map(
          (participant) => {

            const participantCatCod =
              String(
                participant.catCod || ''
              ).trim();


            /*
             * Solo afecta a los participantes
             * pertenecientes a esta categoría.
             */
            if (
              participantCatCod !== catCod
            ) {

              return participant;
            }


            /*
             * DNS y DSQ no tienen tiempo
             * que recalibrar.
             */
            if (
              Number(
                participant.dns || 0
              ) !== 0
              ||
              Number(
                participant.disqualified || 0
              ) !== 0
            ) {

              return participant;
            }


            /*
             * Si todavía no registró llegada,
             * no hay nada que recalibrar.
             */
            if (
              !participant.registeredTime1 ||
              participant.registeredTime1 <= 0
            ) {

              return participant;
            }


            const updatedParticipant = {
              ...participant
            };


            const newRegisteredTime1 =
              updatedParticipant.registeredTime1 -
              deltaMs;


            updatedParticipant.registeredTime1 =
              Math.max(
                0,
                newRegisteredTime1
              );


            updatedParticipant.totalTime =
              updatedParticipant.registeredTime1 +
              (
                updatedParticipant.registeredTime2 ||
                0
              ) +
              (
                updatedParticipant.registeredTime3 ||
                0
              );


            return updatedParticipant;
          }
        );


      return {
        ...state,
        participantList: newList
      };
    }


    /*
     * =======================================================
     * IMPORT
     * =======================================================
     */
    case actionTypes.IMPORT_DATA:

      /*
       * Los padrones anteriores no tienen
       * necesariamente la propiedad dns.
       *
       * La normalizamos a 0.
       */
      const importedParticipantList =
        Array.isArray(
          action.participantList
        )
          ? action.participantList.map(
            (participant) => ({
              ...participant,

              dns:
                Number(
                  participant.dns || 0
                )
            })
          )
          : [];


      return {
        ...state,

        participantList:
          importedParticipantList,

        infoList:
          action.infoList,

        catStats:
          action.catStats,

        gralStats:
          action.gralStats
      };


    /*
     * =======================================================
     * RESET
     * =======================================================
     */
    case actionTypes.RESET_TIMER:

      return {
        ...state,

        participantList: [],

        infoList: [],

        catStats: [],

        gralStats: {}
      };


    /*
     * =======================================================
     * STOP
     * =======================================================
     */
    case actionTypes.STOP_TIMER:

      let abandonos = [];


      /*
       * Por ahora conservamos el comportamiento
       * existente.
       *
       * DNS y DSQ no son considerados pendientes.
       */
      abandonos =
        newList.filter(
          (participant) => {

            return (
              participant.registeredTime1 === 0
              &&
              Number(
                participant.dns || 0
              ) === 0
              &&
              Number(
                participant.disqualified || 0
              ) === 0
            );
          }
        );


      for (
        let index = 0;
        index < abandonos.length;
        index++
      ) {

        abandonos[index]['disabled'] = true;
      }


      return {
        ...state
      };


    default:

      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer-register-time.js